import { Component, OnInit, ViewChild } from '@angular/core';
import { DashService } from '../dash.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-maps',
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css']
})
export class MapsComponent implements OnInit {

  geoPositions = [];
  readonly position = { lat: 28.644800, lng: 77.216721 };
  private dashDataInfoSub: Subscription;
  custInfo: any;
  totalHubs: number;
  isLoading = true;

  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow
  markerContent: any;
  openInfo(marker: MapMarker, content) {
    console.log(content);
    this.markerContent = content
    if(this.infoWindow)
      this.infoWindow.open(marker)
  }

  constructor(public dashService: DashService) {
    this.dashDataInfoSub = this.dashService.getdashInfoDataListener().subscribe(dashDataInfoStatus => {
      this.custInfo = this.dashService.custInfo
      console.log(this.custInfo)
      this.initializeMapMarkers()
    });
  }

  initializeMapMarkers() {
    this.geoPositions = this.custInfo;
    this.isLoading = false;
  }

  ngOnInit(): void {
    this.dashService.fetchData()
  }

}
